export function BulkDelete(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-library/bulk-delete`;
}

export function BulkPin(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-library/bulk-pin`;
}

export function BulkUnpin(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-library/bulk-unpin`;
}

export function Feed(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-library/feed`;
}

export function FeedCollection(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-library/collections/${trainingCollectionID}/feed`;
}

export function GroupShareTargets(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-library/group-share-targets`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-library`;
}

export function Pin(organizationID: number, itemType: string, ID: number): string {
	return `/v1/organizations/${organizationID}/training-library/${itemType}/${ID}/pin`;
}

export function Unpin(organizationID: number, itemType: string, ID: number): string {
	return `/v1/organizations/${organizationID}/training-library/${itemType}/${ID}/pin`;
}

